import { render, staticRenderFns } from "./AxLoginWeb.vue?vue&type=template&id=52f1533a&"
import script from "./AxLoginWeb.vue?vue&type=script&lang=ts&"
export * from "./AxLoginWeb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports